// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
import { createImageService } from "../lib/services/create-image-service.js";
import { WMSService } from "./ogc/wms-service.js";
import { ArcGISImageService } from "./arcgis/arcgis-image-service.js";
const SERVICES = [WMSService, ArcGISImageService];
/**
 * Creates an image source
 * If type is not supplied, will try to automatically detect the the
 * @param url URL to the image source
 * @param type type of source. if not known, set to 'auto'
 * @returns an ImageSource instance
 */
export function createImageSource(props) {
    return createImageService(props, SERVICES);
}
